import * as React from 'react';
import { NotificationBanner } from '@wix/wix-base-ui/lib/esm';
import type { IWbuNotificationBannerProps } from '../WbuNotificationBanner.props';
import WbuContainer from '../../WbuContainer/WbuContainer';
import './style/WbuNotificationBanner.global.scss';
import { getDataAttributes } from '../../../common/utils';
import { classes } from './style/WbuNotificationBanner.st.css';

const WbuNotificationBanner: React.FC<IWbuNotificationBannerProps> = props => {
  const {
    id,
    className,
    label,
    linkText,
    linkUrl,
    iconTooltipText,
    skin,
    multiline,
  } = props;

  return (
    <WbuContainer
      id={id}
      {...getDataAttributes(props)}
      className={className}
      classes={[classes.root]}
    >
      <NotificationBanner
        text={label || 'Notification Banner'}
        skin={skin}
        key={skin}
        link={{
          label: linkText,
          href: linkUrl,
          target: '_blank',
        }}
        icon={
          iconTooltipText
            ? {
                type: skin === 'alert' ? 'alert' : 'info',
                tooltipText: iconTooltipText,
              }
            : undefined
        }
        multiline={multiline}
      />
    </WbuContainer>
  );
};

export default WbuNotificationBanner;
